// has to be built by standalone script in package.json as backstage app doesn't support tailwind nor extending the build by default
import './tailwind/dist/tailwind.min.css';
import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import app from './App';
import '@backstage/ui/css/styles.css';
import './theme/bui.css';

ReactDOM.createRoot(document.getElementById('root')!).render(app);
